"use client";

import { createContext, useContext } from "react";
import type { CSSProperties } from "react";
import type { SocialHandlers, WalletHandlers } from "../types";
import type { SocialId, WalletId } from "../constants";

export interface WalletConnectModalContextValue {
  theme: "dark" | "light";
  isMobile: boolean;
  open: boolean;
  setOpen: (open: boolean) => void;
  close: () => void;
  wallets: WalletHandlers;
  activeWalletIds: WalletId[];
  socialProviders: SocialHandlers;
  activeSocialIds: SocialId[];
  termsUrl?: string;
  privacyUrl?: string;
  isDetected: (rdns: string) => boolean;
  portalStyle?: CSSProperties;
}

export const WalletConnectModalContext =
  createContext<WalletConnectModalContextValue | null>(null);

export function useWalletConnectModalContext() {
  const ctx = useContext(WalletConnectModalContext);
  if (!ctx) {
    throw new Error(
      "WalletConnectModal compound components must be used within <WalletConnectModal>",
    );
  }
  return ctx;
}
